var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("pain008.list_trans_file") } },
    [
      _c("template", { slot: "pageContent" }, [
        _vm.isSmartphoneOS
          ? _c("div", { attrs: { slot: "fixed" }, slot: "fixed" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "44px",
                    width: "100%",
                  },
                },
                [
                  _c("cm-messages-filter", {
                    staticClass: "researchfilter",
                    staticStyle: { position: "relative", "z-index": "10" },
                    attrs: {
                      filterType: "list",
                      mode: this.mode,
                      propedServiceId: "9",
                      countResult:
                        _vm.paginationObject.nbResultsTotal.toString(),
                    },
                    on: {
                      refreshInbox: function ($event) {
                        return _vm.refreshInbox()
                      },
                      applyFilter: function ($event) {
                        return _vm.applyFilter($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "listPage", staticStyle: { overflow: "hidden" } },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c("div", { staticClass: "requestsList" }, [
                      !_vm.isSmartphoneOS
                        ? _c(
                            "div",
                            [
                              _c("cm-messages-filter", {
                                staticClass: "researchfilter",
                                staticStyle: {
                                  position: "relative",
                                  "z-index": "10",
                                },
                                attrs: {
                                  filterType: "list",
                                  mode: this.mode,
                                  randomId: _vm.randomId,
                                  propedServiceId: "9",
                                  countResult:
                                    _vm.paginationObject.nbResultsTotal.toString(),
                                },
                                on: {
                                  applyFilter: function ($event) {
                                    return _vm.applyFilter($event)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isSmartphoneOS
                        ? _c("div", { style: _vm.customMobileLayoutStyle })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "justify-content-center" },
                      [
                        _c("b-col", { attrs: { sm: "12" } }, [
                          _c("hr", { staticClass: "w-100" }),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      {
                        staticClass: "form-group justify-content-start m-0 p-0",
                      },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "m-0 p-0 mb-2",
                            attrs: { md: "2", cols: "6" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "mr-2 text-left cursor",
                                class: {
                                  "active-tab": _vm.currentTab === "list",
                                  "inactive-tab": _vm.currentTab !== "list",
                                },
                                attrs: { size: "sm" },
                                on: {
                                  click: function ($event) {
                                    return _vm.choseTable("list")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "fa-duotone fa-file" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("pain008.list_import_file")) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "m-0 p-0 mb-2",
                            attrs: { md: "2", cols: "6" },
                          },
                          [
                            _vm.canSeeDetails
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "mr-2 text-left cursor",
                                    class: {
                                      "active-tab": _vm.currentTab === "data",
                                      "inactive-tab": _vm.currentTab !== "data",
                                    },
                                    attrs: { size: "sm" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.choseTable("data")
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-duotone fa-file-lines",
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("pain008.data_select_file")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "m-0 p-0 mb-2", attrs: { md: "2" } },
                          [
                            _vm.canSeeDetails
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "mr-2 text-center cursor",
                                    class: {
                                      "active-tab":
                                        _vm.currentTab === "details",
                                      "inactive-tab":
                                        _vm.currentTab !== "details",
                                    },
                                    attrs: { size: "sm" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.choseTable("details")
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-duotone fa-grid",
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("pain008.detail_select_file")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "m-0 p-0", attrs: { sm: "2" } },
                          [
                            _vm.canSeeHisto
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "mr-2 text-left cursor",
                                    class: {
                                      "active-tab":
                                        _vm.currentTab === "historique",
                                      "inactive-tab":
                                        _vm.currentTab !== "historique",
                                    },
                                    attrs: { size: "sm" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.choseTable("historique")
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-duotone fa-clock-rotate-left",
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("pain008.history_modi")) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.activateSpinner
                      ? _c("spinner")
                      : _vm.currentTab === "list"
                      ? _c(
                          "div",
                          [
                            _vm.items.length
                              ? _c("b-table", {
                                  ref: "tablePain008Close",
                                  staticClass: "mt-3",
                                  attrs: {
                                    hover: "",
                                    responsive: "",
                                    items: _vm.items,
                                    fields: _vm.fields,
                                    "sort-by": _vm.sortBy,
                                    "sort-desc": _vm.sortDir,
                                    id: "table" + "-" + _vm.randomString,
                                  },
                                  on: {
                                    "update:sortBy": function ($event) {
                                      _vm.sortBy = $event
                                    },
                                    "update:sort-by": function ($event) {
                                      _vm.sortBy = $event
                                    },
                                    "update:sortDesc": function ($event) {
                                      _vm.sortDir = $event
                                    },
                                    "update:sort-desc": function ($event) {
                                      _vm.sortDir = $event
                                    },
                                    "head-clicked": _vm.sortTable,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(fileImport)",
                                        fn: function (row) {
                                          return [
                                            _vm.checkStatus(
                                              row.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    class: _vm.canSeeDetails
                                                      ? "cursor"
                                                      : "",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row.item.IdFile
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    row.item.fileImport.length >
                                                    20
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                            on: {
                                                              mouseover:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.showFullFileName(
                                                                    row.index
                                                                  )
                                                                },
                                                              mouseleave:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  return _vm.hideFullFileName(
                                                                    row.index
                                                                  )
                                                                },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  row.item
                                                                    .fileImport
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                            _vm.isMouseOver[
                                                              row.index
                                                            ]
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        position:
                                                                          "absolute",
                                                                        "background-color":
                                                                          "#fff",
                                                                        border:
                                                                          "1px solid #ccc",
                                                                        padding:
                                                                          "5px",
                                                                        "z-index":
                                                                          "1000",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        row.item
                                                                          .fileImport
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                row.item
                                                                  .fileImport
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  row.item.fileImport.length >
                                                  20
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                          on: {
                                                            mouseover:
                                                              _vm.showFullFileName,
                                                            mouseleave:
                                                              _vm.hideFullFileName,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                row.item
                                                                  .fileImport
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                          _vm.isMouseOver[
                                                            row.index
                                                          ]
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    position:
                                                                      "absolute",
                                                                    "background-color":
                                                                      "#fff",
                                                                    border:
                                                                      "1px solid #ccc",
                                                                    padding:
                                                                      "5px",
                                                                    "z-index":
                                                                      "1000",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      row.item
                                                                        .fileImport
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-left",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.item
                                                                .fileImport
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(dateImport)",
                                        fn: function (row_d) {
                                          return [
                                            _vm.checkStatus(
                                              row_d.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    class: _vm.canSeeDetails
                                                      ? "cursor"
                                                      : "",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_d.item.IdFile
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.convertTime(
                                                            row_d.item
                                                              .dateImport
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.convertTime(
                                                          row_d.item.dateImport
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(nbTotalElem)",
                                        fn: function (row_nbe) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                class: _vm.canSeeDetails
                                                  ? "cursor"
                                                  : "",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showData(
                                                      row_nbe.item.idFile
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      row_nbe.item.nbTotalElem
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(total)",
                                        fn: function (row_tot) {
                                          return [
                                            _vm.checkStatus(
                                              row_tot.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    class: _vm.canSeeDetails
                                                      ? "cursor"
                                                      : "",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_tot.item.IdFile
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_tot.item.total
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_tot.item.total
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(error)",
                                        fn: function (row_error) {
                                          return [
                                            _vm.checkStatus(
                                              row_error.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    class: _vm.canSeeDetails
                                                      ? "cursor"
                                                      : "",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_error.item.IdFile
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_error.item.error
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_error.item.error
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(validated)",
                                        fn: function (row_validated) {
                                          return [
                                            _vm.checkStatus(
                                              row_validated.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    class: _vm.canSeeDetails
                                                      ? "cursor"
                                                      : "",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_validated.item
                                                            .IdFile
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_validated.item
                                                            .validated
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_validated.item
                                                          .validated
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(process)",
                                        fn: function (row_process) {
                                          return [
                                            _vm.checkStatus(
                                              row_process.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    class: _vm.canSeeDetails
                                                      ? "cursor"
                                                      : "",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_process.item
                                                            .IdFile
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_process.item
                                                            .process
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_process.item.process
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(verif)",
                                        fn: function (row_verif) {
                                          return [
                                            _vm.checkStatus(
                                              row_verif.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    class: _vm.canSeeDetails
                                                      ? "cursor"
                                                      : "",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_verif.item.IdFile
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_verif.item.verif
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_verif.item.verif
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(refus)",
                                        fn: function (row_refus) {
                                          return [
                                            _vm.checkStatus(
                                              row_refus.item.globalState
                                            )
                                              ? _c(
                                                  "div",
                                                  {
                                                    class: _vm.canSeeDetails
                                                      ? "cursor"
                                                      : "",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_refus.item.IdFile
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_refus.item.refus
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_refus.item.refus
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(globalState)",
                                        fn: function (row_state) {
                                          return [
                                            row_state.item.globalState ===
                                            _vm.$t("pain008.file_refused")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-danger cursor",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_state.item
                                                            .globalState
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : row_state.item.globalState ===
                                                _vm.$t(
                                                  "pain008.processed_pending"
                                                )
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-muted cursor",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_state.item.IdFile
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_state.item
                                                            .globalState
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm.checkStatus(
                                                  row_state.item.globalState
                                                )
                                              ? _c(
                                                  "div",
                                                  {
                                                    class: _vm.canSeeDetails
                                                      ? "cursor"
                                                      : "",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showData(
                                                          row_state.item.IdFile
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row_state.item
                                                            .globalState
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        row_state.item
                                                          .globalState
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(FolderClose)",
                                        fn: function (row_close) {
                                          return [
                                            row_close.item.FolderClose !==
                                            "Cadenas"
                                              ? _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      {
                                                        class: _vm.canSeeDetails
                                                          ? "cursor"
                                                          : "",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _c("u", [
                                                            _vm._v(
                                                              _vm._s(
                                                                row_close.item
                                                                  .FolderClose
                                                              )
                                                            ),
                                                          ]),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _c("b-row", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "cursor mx-auto",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-duotone fa-lock text-muted text-center",
                                                      }),
                                                    ]
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "row-details",
                                        fn: function (details_row) {
                                          return [
                                            _c(
                                              "b-card",
                                              {
                                                staticClass:
                                                  "bg-white border-0 shadow-none p-0 m-0",
                                              },
                                              [
                                                _vm._l(
                                                  details_row.item.detailsOK,
                                                  function (x) {
                                                    return _c(
                                                      "b-row",
                                                      {
                                                        key: x,
                                                        staticClass:
                                                          "my-1 mx-5 justify-content-center",
                                                      },
                                                      [
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                            attrs: { md: "2" },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-success font-weight-bold",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "pain008.valid_elements_reissued"
                                                                      )
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                            attrs: { md: "3" },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  x.namefile
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                            attrs: { md: "2" },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  x.dateimport
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                            attrs: { md: "1" },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa-light fa-arrow-right",
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                            attrs: { md: "1" },
                                                          },
                                                          [
                                                            x.nblignes <= 1
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        x.nblignes
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "pain008.line"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        x.nblignes
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "pain008.lines"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  details_row.item.detailsKO,
                                                  function (x) {
                                                    return _c(
                                                      "b-row",
                                                      {
                                                        key: x,
                                                        staticClass:
                                                          "my-1 mx-5 justify-content-center",
                                                      },
                                                      [
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                            attrs: { md: "2" },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-danger font-weight-bold pt-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "pain008.rejected_elements_reissued"
                                                                      )
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                            attrs: { md: "3" },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  x.namefile
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                            attrs: { md: "2" },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  x.dateimport
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                            attrs: { md: "1" },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa-light fa-arrow-right",
                                                            }),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "text-left",
                                                            attrs: { md: "1" },
                                                          },
                                                          [
                                                            x.nblignes <= 1
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        x.nblignes
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "pain008.line"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ])
                                                              : _c("span", [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        x.nblignes
                                                                      ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "pain008.lines"
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4193661416
                                  ),
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center",
                                  },
                                  [
                                    _c("span", { staticClass: "noResult" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.$t("common.no_result")) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]
                                ),
                            _vm._v(" "),
                            _vm.items.length
                              ? _c(
                                  "b-row",
                                  { staticClass: "justify-content-end mt-5" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mt-3",
                                        attrs: { lg: "2", offset: "10" },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.extractCSV_items()
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-arrow-up-from-bracket",
                                            }),
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("pain008.extract_list")
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mt-5" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("cm-pagination", {
                                      attrs: {
                                        maxResultsByPage:
                                          _vm.paginationObject.maxResults,
                                        firstIndex:
                                          _vm.paginationObject.firstIndex,
                                        nbResultsTotal:
                                          _vm.paginationObject.nbResultsTotal,
                                        refreshEvent:
                                          _vm.paginationObject.refresh,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm.currentTab === "data"
                      ? _c(
                          "div",
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mt-3",
                                    attrs: { lg: "2", offset: "8" },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.resendExpired()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-solid fa-refresh",
                                          staticStyle: {
                                            "margin-right": "5px",
                                          },
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("pain008.refresh_expired")
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "mt-3", attrs: { lg: "2" } },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.extractCSV_itemsData()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-arrow-up-from-bracket",
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("pain008.extract_list")
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "b-tabs",
                              {
                                attrs: {
                                  "active-nav-item-class":
                                    "active-blue font-weight-bold",
                                },
                                model: {
                                  value: _vm.tabType,
                                  callback: function ($$v) {
                                    _vm.tabType = $$v
                                  },
                                  expression: "tabType",
                                },
                              },
                              [
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      title: _vm.$t("pain008.legal_person"),
                                      active: _vm.tabType === 0,
                                    },
                                  },
                                  [
                                    this.items[this.currentIndexList]
                                      ? _c(
                                          "b-row",
                                          {
                                            staticClass:
                                              "my-3 justify-content-around",
                                          },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#6b6aea",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.imported_file"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        this.items[
                                                          this.currentIndexList
                                                        ].fileImport
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    this.items[this.currentIndexList]
                                      ? _c(
                                          "b-row",
                                          {
                                            staticClass:
                                              "my-3 justify-content-around",
                                          },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "pain008.total_2"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.nbTotalRequest
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "2" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#11b1fd",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.being_processed"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbBeingProcessedRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "orange",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.to_verify"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbToVerifyRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#47d89c",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.validated"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbValidatedRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#f54336",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.refused"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbRefusedRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#f54336",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.in_error"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbErrorRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#888888",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.ignored"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbIgnoredRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#47d89c",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t("pain008.paid")
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#939393",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      : " +
                                                        _vm._s(
                                                          _vm.nbPaidRequest
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.itemsDataPM.length
                                      ? _c(
                                          "div",
                                          [
                                            _c("b-table", {
                                              ref: "tablePain008DataClose",
                                              attrs: {
                                                hover: "",
                                                responsive: "",
                                                "sticky-header": "",
                                                items: _vm.itemsDataPM,
                                                fields: _vm.fieldsDataPM,
                                                "sort-by": _vm.sortByData,
                                                "sort-desc": _vm.sortDirData,
                                                id:
                                                  "table-data" +
                                                  "-" +
                                                  _vm.randomString,
                                              },
                                              on: {
                                                "update:sortBy": function (
                                                  $event
                                                ) {
                                                  _vm.sortByData = $event
                                                },
                                                "update:sort-by": function (
                                                  $event
                                                ) {
                                                  _vm.sortByData = $event
                                                },
                                                "update:sortDesc": function (
                                                  $event
                                                ) {
                                                  _vm.sortDirData = $event
                                                },
                                                "update:sort-desc": function (
                                                  $event
                                                ) {
                                                  _vm.sortDirData = $event
                                                },
                                                "head-clicked":
                                                  _vm.sortTableData,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "head(validAll)",
                                                    fn: function () {
                                                      return undefined
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "head(rejectAll)",
                                                    fn: function () {
                                                      return undefined
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "cell(name)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item.name.length >
                                                        20
                                                          ? _c(
                                                              "div",
                                                              {
                                                                class:
                                                                  _vm.canSeeDetails
                                                                    ? "cursor"
                                                                    : "",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                  mouseover:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showFullFileName(
                                                                        row.item
                                                                          .index
                                                                      )
                                                                    },
                                                                  mouseleave:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.hideFullFileName(
                                                                        row.item
                                                                          .index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      row.item
                                                                        .name
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                                _vm.isMouseOver[
                                                                  row.item.index
                                                                ]
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            position:
                                                                              "absolute",
                                                                            "background-color":
                                                                              "#fff",
                                                                            border:
                                                                              "1px solid #ccc",
                                                                            padding:
                                                                              "5px",
                                                                            "z-index":
                                                                              "1000",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                          " +
                                                                            _vm._s(
                                                                              row
                                                                                .item
                                                                                .name
                                                                            ) +
                                                                            "\n                        "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                class:
                                                                  _vm.canSeeDetails
                                                                    ? "cursor"
                                                                    : "",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      row.item
                                                                        .name
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(iban)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            class:
                                                              _vm.canSeeDetails
                                                                ? "cursor"
                                                                : "",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  row.item.iban
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(siren)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            class:
                                                              _vm.canSeeDetails
                                                                ? "cursor"
                                                                : "",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  row.item.siren
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(verifIban)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item.verifIban ===
                                                        "Faux"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cursor text-danger",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      row.item
                                                                        .verifIban
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            )
                                                          : _c("div", {
                                                              class:
                                                                _vm.canSeeDetails
                                                                  ? "cursor"
                                                                  : "",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    row.item
                                                                      .verifIban
                                                                  ),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showDetails(
                                                                      row.index
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(verifSiren)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item.verifSiren ===
                                                        "Faux"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cursor text-danger",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      row.item
                                                                        .verifSiren
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            )
                                                          : _c("div", {
                                                              class:
                                                                _vm.canSeeDetails
                                                                  ? "cursor"
                                                                  : "",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    row.item
                                                                      .verifSiren
                                                                  ),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showDetails(
                                                                      row.index
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(score)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            class:
                                                              _vm.canSeeDetails
                                                                ? "cursor"
                                                                : "",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  row.item.score
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(stateVerif)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            class:
                                                              _vm.canSeeDetails
                                                                ? "cursor"
                                                                : "",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.verifStatus(
                                                                    row.item
                                                                      .stateVerif
                                                                  )
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(validAll)",
                                                    fn: function (row) {
                                                      return [
                                                        _vm.canDoDecision &&
                                                        row.item
                                                          .StatusValidation ===
                                                          "1"
                                                          ? [
                                                              _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.decideLine(
                                                                          row,
                                                                          1
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      row.item
                                                                        .validAll,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          row.item,
                                                                          "validAll",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "row.item.validAll",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "u",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "#11b1fd",
                                                                          "font-weight":
                                                                            "400",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "pain008.validate"
                                                                            )
                                                                          ) +
                                                                          "\n                          "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : row.item
                                                              .StatusValidation ===
                                                            "2"
                                                          ? [
                                                              _c(
                                                                "div",
                                                                {
                                                                  class:
                                                                    _vm.canSeeDetails
                                                                      ? "cursor"
                                                                      : "",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.showDetails(
                                                                          row.index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "pain008.validated"
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : [
                                                              _c("div", {
                                                                class:
                                                                  _vm.canSeeDetails
                                                                    ? "cursor"
                                                                    : "",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ],
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(rejectAll)",
                                                    fn: function (row) {
                                                      return [
                                                        _vm.canDoDecision &&
                                                        row.item
                                                          .StatusValidation ===
                                                          "1"
                                                          ? [
                                                              _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.decideLine(
                                                                          row,
                                                                          0
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      row.item
                                                                        .rejectAll,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          row.item,
                                                                          "rejectAll",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "row.item.rejectAll",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "u",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "#000000",
                                                                          "font-weight":
                                                                            "400",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "pain008.refus"
                                                                            )
                                                                          ) +
                                                                          "\n                          "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : row.item
                                                              .StatusValidation ===
                                                            "3"
                                                          ? [
                                                              _c(
                                                                "div",
                                                                {
                                                                  class:
                                                                    _vm.canSeeDetails
                                                                      ? "cursor"
                                                                      : "",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.showDetails(
                                                                          row.index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "pain008.denied"
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : [
                                                              _c("div", {
                                                                class:
                                                                  _vm.canSeeDetails
                                                                    ? "cursor"
                                                                    : "",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ],
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(paid)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item
                                                          .StatusValidation ===
                                                        "6"
                                                          ? [
                                                              _c(
                                                                "div",
                                                                {
                                                                  class:
                                                                    _vm.canSeeDetails
                                                                      ? "cursor"
                                                                      : "",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.showDetails(
                                                                          row.index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "pain008.paid"
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1803799087
                                              ),
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              { staticClass: "mt-5" },
                                              [
                                                _c(
                                                  "b-col",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { cols: "12" } },
                                                      [
                                                        _c("cm-pagination", {
                                                          attrs: {
                                                            maxResultsByPage:
                                                              _vm
                                                                .paginationObjectData
                                                                .maxResults,
                                                            firstIndex:
                                                              _vm
                                                                .paginationObjectData
                                                                .firstIndex,
                                                            nbResultsTotal:
                                                              _vm
                                                                .paginationObjectData
                                                                .nbResultsTotal,
                                                            refreshEvent:
                                                              _vm
                                                                .paginationObjectData
                                                                .refresh,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "noResult" },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t("pain008.no_PM")
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-tab",
                                  {
                                    attrs: {
                                      title: _vm.$t("pain008.physical_person"),
                                      active: _vm.tabType === 1,
                                    },
                                  },
                                  [
                                    this.items[this.currentIndexList]
                                      ? _c(
                                          "b-row",
                                          {
                                            staticClass:
                                              "my-3 justify-content-around",
                                          },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "mt-3 font-weight-bold",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "#6b6aea",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pain008.imported_file"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        this.items[
                                                          this.currentIndexList
                                                        ].fileImport
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "mt-3 font-weight-bold",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("pain008.total_2")
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.nbTotalRequest) +
                                                  "\n                    "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "mt-3 font-weight-bold",
                                            attrs: { cols: "2" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#11b1fd",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "pain008.being_processed"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#939393",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      : " +
                                                    _vm._s(
                                                      _vm.nbBeingProcessedRequest
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "mt-3 font-weight-bold",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "orange",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "pain008.to_verify"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#939393",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      : " +
                                                    _vm._s(
                                                      _vm.nbToVerifyRequest
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "mt-3 font-weight-bold",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#47d89c",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "pain008.validated"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#939393",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      : " +
                                                    _vm._s(
                                                      _vm.nbValidatedRequest
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "mt-3 font-weight-bold",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#f54336",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t("pain008.refused")
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#939393",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      : " +
                                                    _vm._s(
                                                      _vm.nbRefusedRequest
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "mt-3 font-weight-bold",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#f54336",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t("pain008.in_error")
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#939393",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      : " +
                                                    _vm._s(_vm.nbErrorRequest) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "mt-3 font-weight-bold",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#888888",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t("pain008.ignored")
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#939393",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      : " +
                                                    _vm._s(
                                                      _vm.nbIgnoredRequest
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "mt-3 font-weight-bold",
                                            attrs: { cols: "1" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#47d89c",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.$t("pain008.paid")
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#939393",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      : " +
                                                    _vm._s(_vm.nbPaidRequest) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.itemsDataPP.length
                                      ? _c(
                                          "div",
                                          [
                                            _c("b-table", {
                                              ref: "tablePain008DataClose",
                                              attrs: {
                                                hover: "",
                                                responsive: "",
                                                "sticky-header": "",
                                                items: _vm.itemsDataPP,
                                                fields: _vm.fieldsDataPP,
                                                "sort-by": _vm.sortByData,
                                                "sort-desc": _vm.sortDirData,
                                                id:
                                                  "table-data" +
                                                  "-" +
                                                  _vm.randomString,
                                              },
                                              on: {
                                                "update:sortBy": function (
                                                  $event
                                                ) {
                                                  _vm.sortByData = $event
                                                },
                                                "update:sort-by": function (
                                                  $event
                                                ) {
                                                  _vm.sortByData = $event
                                                },
                                                "update:sortDesc": function (
                                                  $event
                                                ) {
                                                  _vm.sortDirData = $event
                                                },
                                                "update:sort-desc": function (
                                                  $event
                                                ) {
                                                  _vm.sortDirData = $event
                                                },
                                                "head-clicked":
                                                  _vm.sortTableData,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "head(validAll)",
                                                    fn: function () {
                                                      return undefined
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "head(rejectAll)",
                                                    fn: function () {
                                                      return undefined
                                                    },
                                                    proxy: true,
                                                  },
                                                  {
                                                    key: "cell(name)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item.name.length >
                                                        20
                                                          ? _c(
                                                              "div",
                                                              {
                                                                class:
                                                                  row.item
                                                                    .StatusValidation !==
                                                                  "4"
                                                                    ? "cursor"
                                                                    : "",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                  mouseover:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showFullFileName(
                                                                        row.item
                                                                          .index
                                                                      )
                                                                    },
                                                                  mouseleave:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.hideFullFileName(
                                                                        row.item
                                                                          .index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      row.item
                                                                        .name
                                                                    ) +
                                                                    "\n                        "
                                                                ),
                                                                _vm.isMouseOver[
                                                                  row.item.index
                                                                ]
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            position:
                                                                              "absolute",
                                                                            "background-color":
                                                                              "#fff",
                                                                            border:
                                                                              "1px solid #ccc",
                                                                            padding:
                                                                              "5px",
                                                                            "z-index":
                                                                              "1000",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                          " +
                                                                            _vm._s(
                                                                              row
                                                                                .item
                                                                                .name
                                                                            ) +
                                                                            "\n                        "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                class:
                                                                  _vm.canSeeDetails
                                                                    ? "cursor"
                                                                    : "",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      row.item
                                                                        .name
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(iban)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            class:
                                                              _vm.canSeeDetails
                                                                ? "cursor"
                                                                : "",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  row.item.iban
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(siren)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            class:
                                                              _vm.canSeeDetails
                                                                ? "cursor"
                                                                : "",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  row.item.siren
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(verifIban)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item.verifIban ===
                                                        "Faux"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cursor text-danger",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      row.item
                                                                        .verifIban
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            )
                                                          : _c("div", {
                                                              class:
                                                                _vm.canSeeDetails
                                                                  ? "cursor"
                                                                  : "",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    row.item
                                                                      .verifIban
                                                                  ),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showDetails(
                                                                      row.index
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(verifSiren)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item.verifSiren ===
                                                        "Faux"
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "cursor text-danger",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      row.item
                                                                        .verifSiren
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                              ]
                                                            )
                                                          : _c("div", {
                                                              class:
                                                                _vm.canSeeDetails
                                                                  ? "cursor"
                                                                  : "",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    row.item
                                                                      .verifSiren
                                                                  ),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showDetails(
                                                                      row.index
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(score)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            class:
                                                              _vm.canSeeDetails
                                                                ? "cursor"
                                                                : "",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  row.item.score
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(stateVerif)",
                                                    fn: function (row) {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            class:
                                                              _vm.canSeeDetails
                                                                ? "cursor"
                                                                : "",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showDetails(
                                                                  row.index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.verifStatus(
                                                                    row.item
                                                                      .stateVerif
                                                                  )
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(validAll)",
                                                    fn: function (row) {
                                                      return [
                                                        _vm.canDoDecision &&
                                                        row.item
                                                          .StatusValidation ===
                                                          "1"
                                                          ? [
                                                              _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.decideLine(
                                                                          row,
                                                                          1
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      row.item
                                                                        .validAll,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          row.item,
                                                                          "validAll",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "row.item.validAll",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "u",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "#11b1fd",
                                                                          "font-weight":
                                                                            "400",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "pain008.validate"
                                                                            )
                                                                          ) +
                                                                          "\n                          "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : row.item
                                                              .StatusValidation ===
                                                            "2"
                                                          ? [
                                                              _c(
                                                                "div",
                                                                {
                                                                  class:
                                                                    _vm.canSeeDetails
                                                                      ? "cursor"
                                                                      : "",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.showDetails(
                                                                          row.index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "pain008.validated"
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : [
                                                              _c("div", {
                                                                class:
                                                                  _vm.canSeeDetails
                                                                    ? "cursor"
                                                                    : "",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ],
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(rejectAll)",
                                                    fn: function (row) {
                                                      return [
                                                        _vm.canDoDecision &&
                                                        row.item
                                                          .StatusValidation ===
                                                          "1"
                                                          ? [
                                                              _c(
                                                                "b-form-checkbox",
                                                                {
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.decideLine(
                                                                          row,
                                                                          0
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      row.item
                                                                        .rejectAll,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          row.item,
                                                                          "rejectAll",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "row.item.rejectAll",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "u",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "#000000",
                                                                          "font-weight":
                                                                            "400",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "pain008.refus"
                                                                            )
                                                                          ) +
                                                                          "\n                          "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : row.item
                                                              .StatusValidation ===
                                                            "3"
                                                          ? [
                                                              _c(
                                                                "div",
                                                                {
                                                                  class:
                                                                    _vm.canSeeDetails
                                                                      ? "cursor"
                                                                      : "",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.showDetails(
                                                                          row.index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "pain008.denied"
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : [
                                                              _c("div", {
                                                                class:
                                                                  _vm.canSeeDetails
                                                                    ? "cursor"
                                                                    : "",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.showDetails(
                                                                        row.index
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ],
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(paid)",
                                                    fn: function (row) {
                                                      return [
                                                        row.item
                                                          .StatusValidation ===
                                                        "6"
                                                          ? [
                                                              _c(
                                                                "div",
                                                                {
                                                                  class:
                                                                    _vm.canSeeDetails
                                                                      ? "cursor"
                                                                      : "",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.showDetails(
                                                                          row.index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "pain008.paid"
                                                                        )
                                                                      ) +
                                                                      "\n                        "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2443451847
                                              ),
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "b-row",
                                              { staticClass: "mt-5" },
                                              [
                                                _c(
                                                  "b-col",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { cols: "12" } },
                                                      [
                                                        _c("cm-pagination", {
                                                          attrs: {
                                                            maxResultsByPage:
                                                              _vm
                                                                .paginationObjectData
                                                                .maxResults,
                                                            firstIndex:
                                                              _vm
                                                                .paginationObjectData
                                                                .firstIndex,
                                                            nbResultsTotal:
                                                              _vm
                                                                .paginationObjectData
                                                                .nbResultsTotal,
                                                            refreshEvent:
                                                              _vm
                                                                .paginationObjectData
                                                                .refresh,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-center",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "noResult" },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.$t("pain008.no_PP")
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.canDoDecision && _vm.itemsData.length
                              ? _c(
                                  "b-row",
                                  { staticClass: "justify-content-end mt-3" },
                                  [
                                    _vm.itemsData.filter(function (elem) {
                                      return (
                                        elem.stateVerif !== "10" &&
                                        elem.StatusValidation === "1"
                                      )
                                    }).length
                                      ? [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "mt-3",
                                              attrs: { lg: "2", cols: "4" },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "btn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.effacer()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "pain008.clear_label"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "mt-3",
                                              attrs: { lg: "2", cols: "4" },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.enregistrer()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t("pain008.sve")
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm.currentTab === "details"
                      ? _c(
                          "div",
                          [
                            _c(
                              "b-row",
                              { staticClass: "mb-3 justify-content-between" },
                              [
                                _vm.currentIndexData > 0
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-2",
                                        attrs: { lg: "2", cols: "4" },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.navDetails(-1)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-chevrons-left",
                                            }),
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t("pain008.previous")
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.currentIndexData === 0 &&
                                _vm.currentIndexData < _vm.itemsData.length - 1
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-2",
                                        attrs: {
                                          lg: "2",
                                          cols: "4",
                                          offset: "10",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.navDetails(1)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$t("pain008.next")) +
                                                "\n                  "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-chevrons-right",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm.itemsData.length > 1 &&
                                    _vm.currentIndexData <
                                      _vm.itemsData.length - 1
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-2",
                                        attrs: {
                                          lg: "2",
                                          cols: "4",
                                          offset: "8",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.navDetails(1)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(_vm.$t("pain008.next")) +
                                                "\n                  "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-chevrons-right",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "text-center" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "bandeau0 text-dark",
                                    staticStyle: {
                                      "background-color": "#f1f1f1",
                                    },
                                  },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("pain008.global_response")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.itemsData[_vm.currentIndexData]
                                  .stateVerif === "10"
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "bandeau2",
                                        staticStyle: {
                                          "background-color": "#47d89c",
                                        },
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.verifStatus(
                                                _vm.itemsData[
                                                  _vm.currentIndexData
                                                ].stateVerif
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : this.itemsData[_vm.currentIndexData]
                                      .stateVerif === "1" ||
                                    this.itemsData[_vm.currentIndexData]
                                      .stateVerif === "2"
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "bandeau2 text-dark",
                                        staticStyle: {
                                          "background-color": "#FFCC86",
                                        },
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.verifStatus(
                                                _vm.itemsData[
                                                  _vm.currentIndexData
                                                ].stateVerif
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : this.itemsData[_vm.currentIndexData]
                                      .stateVerif === "99"
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "bandeau2",
                                        staticStyle: {
                                          "background-color": "#888888",
                                        },
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.verifStatus(
                                                _vm.itemsData[
                                                  _vm.currentIndexData
                                                ].stateVerif
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _c("b-col", { staticClass: "bandeau2" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.verifStatus(
                                              _vm.itemsData[
                                                _vm.currentIndexData
                                              ].stateVerif
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "text-center mb-4" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "bandeau0 text-dark",
                                    staticStyle: {
                                      "background-color": "#f1f1f1",
                                    },
                                  },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("pain008.remittance_status")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                this.itemsData[_vm.currentIndexData]
                                  .StatusValidation === "0"
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "bandeau2 text-dark",
                                        staticStyle: {
                                          "background-color": "#FFCC86",
                                        },
                                      },
                                      [_c("b", [_vm._v("-")])]
                                    )
                                  : this.itemsData[_vm.currentIndexData]
                                      .StatusValidation === "1"
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "bandeau2 text-dark",
                                        staticStyle: {
                                          "background-color": "#FFCC86",
                                        },
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "pain008.waiting_decision_2"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm.itemsData[_vm.currentIndexData]
                                      .StatusValidation === "2"
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "bandeau2",
                                        staticStyle: {
                                          "background-color": "#47d89c",
                                        },
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t("pain008.validated"))
                                          ),
                                        ]),
                                      ]
                                    )
                                  : this.itemsData[_vm.currentIndexData]
                                      .StatusValidation === "3"
                                  ? _c("b-col", { staticClass: "bandeau2" }, [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(_vm.$t("pain008.denied"))
                                        ),
                                      ]),
                                    ])
                                  : this.itemsData[_vm.currentIndexData]
                                      .StatusValidation === "4"
                                  ? _c("b-col", { staticClass: "bandeau2" }, [
                                      _c("b", [
                                        _vm._v(_vm._s(_vm.$t("pain008.error"))),
                                      ]),
                                    ])
                                  : this.itemsData[_vm.currentIndexData]
                                      .StatusValidation === "5"
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "bandeau2",
                                        staticStyle: {
                                          "background-color": "#888888",
                                        },
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t("pain008.ignored"))
                                          ),
                                        ]),
                                      ]
                                    )
                                  : this.itemsData[_vm.currentIndexData]
                                      .StatusValidation === "6"
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass: "bandeau2",
                                        staticStyle: {
                                          "background-color": "#47d89c",
                                        },
                                      },
                                      [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(_vm.$t("pain008.paid"))
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "title-label-blue",
                                staticStyle: { width: "350px" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("pain008.check_bank_details")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  overflow: "visible",
                                  height: "290px",
                                },
                              },
                              [
                                _vm.itemsData.length
                                  ? _c("b-table", {
                                      ref: "tablePain008DetailsClose",
                                      attrs: {
                                        hover: "",
                                        fixed: "",
                                        items: _vm.itemsDetails,
                                        fields: _vm.fieldsDetails,
                                        "sort-by": _vm.sortField,
                                        id:
                                          "table-details" +
                                          "-" +
                                          _vm.randomString,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "cell(field)",
                                            fn: function (row) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "pain008.fields." +
                                                            row.item.field
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(value)",
                                            fn: function (row) {
                                              return [
                                                row.item.field === "Type"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "pain008." +
                                                                row.item.value
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            row.item.value
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(details)",
                                            fn: function (row) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.verifAll(
                                                          row.item.details,
                                                          row.item.field
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(result)",
                                            fn: function (row) {
                                              return [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      row.item.result
                                                    ),
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        98548730
                                      ),
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "form-accordion",
                              {
                                attrs: {
                                  title: _vm.$t("pain008.info_add"),
                                  isOpen: false,
                                  isTitleUpperCase: false,
                                },
                              },
                              [
                                _vm.itemsData.length
                                  ? _c("b-table", {
                                      ref: "tablePain008DetailsClose",
                                      attrs: {
                                        hover: "",
                                        fixed: "",
                                        items: _vm.itemsOtherDetails,
                                        fields: _vm.fieldsOtherDetails,
                                        "sort-by": _vm.sortField,
                                        id:
                                          "table-details" +
                                          "-" +
                                          _vm.randomString,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "cell(Date)",
                                            fn: function (row_d) {
                                              return [
                                                _c("div", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.convertTime(
                                                          row_d.item.Date
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        951788513
                                      ),
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.canDoDecision &&
                            _vm.itemsData.filter(function (elem) {
                              return (
                                elem.idrequest ===
                                  _vm.request[_vm.currentIndexData].idrequest &&
                                elem.StatusValidation === "1"
                              )
                            }).length
                              ? [
                                  _c(
                                    "b-row",
                                    { staticClass: "justify-content-end mt-4" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "2", cols: "6" },
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "btn",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.refuser()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("pain008.refus")
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { md: "2", cols: "6" },
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: { variant: "primary" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.validate()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.$t("pain008.validate")
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentTab === "historique"
                      ? _c("div", [
                          _vm.itemsHisto.length
                            ? _c(
                                "div",
                                [
                                  _c("b-table", {
                                    ref: "tablePain008HistoClose",
                                    attrs: {
                                      hover: "",
                                      responsive: "",
                                      "sticky-header": "",
                                      items: _vm.itemsHisto,
                                      fields: _vm.fieldsHisto,
                                      "sort-by": _vm.sortField,
                                      id:
                                        "table-histo" + "-" + _vm.randomString,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "cell(stateVerif)",
                                          fn: function (row) {
                                            return [
                                              _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.verifStatus(
                                                        row.item.stateVerif
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(StatusValidation)",
                                          fn: function (row) {
                                            return [
                                              row.item.StatusValidation ===
                                                "2" ||
                                              row.item.StatusValidation === "6"
                                                ? [
                                                    _c("div", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "pain008.validated"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]),
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              row.item.StatusValidation === "3"
                                                ? [
                                                    _c("div", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "pain008.denied"
                                                            )
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ]),
                                                  ]
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      781345372
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "mt-5" },
                                    [
                                      _c(
                                        "b-col",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("cm-pagination", {
                                                attrs: {
                                                  maxResultsByPage:
                                                    _vm.paginationObjectHisto
                                                      .maxResults,
                                                  firstIndex:
                                                    _vm.paginationObjectHisto
                                                      .firstIndex,
                                                  nbResultsTotal:
                                                    _vm.paginationObjectHisto
                                                      .nbResultsTotal,
                                                  refreshEvent:
                                                    _vm.paginationObjectHisto
                                                      .refresh,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.itemsHisto.length
                                    ? _c(
                                        "b-row",
                                        {
                                          staticClass:
                                            "justify-content-end mt-5",
                                        },
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass: "mt-3",
                                              attrs: { lg: "2", offset: "10" },
                                            },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  attrs: { variant: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.extractCSV_itemsHisto()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa-solid fa-arrow-up-from-bracket",
                                                  }),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "pain008.extract_list"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "d-flex justify-content-center",
                                },
                                [
                                  _c("span", { staticClass: "noResult" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("pain008.no_update")) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }